﻿import {PaymentMethodSearchGateway} from './paymentMethodSearch.gateway';
import {PaymentMethodSearchViewModel} from './paymentMethodSearch.viewmodel';
import {PaymentMethodSearchResultModel} from './paymentMethodSearch.viewmodel';
import * as LogService from "../../core/services/logservice/log.service";
import * as Model from '../../models/models';
import {ScreenLockService} from '../../core/services/screenLockService/screenLock.service';



export class PaymentMethodSearchController {

    private searchViewModel: PaymentMethodSearchViewModel;
    private searchCriteriaModel: Model.ISubmissionSearchCriteria;
 

    static $inject = ['$uibModal', '$state', 'logService', 'paymentMethodSearch.gateway', 'screenLockService'];

    constructor(private $modal: any,
        private $state: ng.ui.IStateService,
        private logger: LogService.ILogService,
        private searchGateway: PaymentMethodSearchGateway,
        private screenLockService: ScreenLockService) {

        this.searchCriteriaModel = new Model.SubmissionSearchCriteria();
        this.activate();
    }

    public activate(): void {

        const loadPageInitializationDataPromise: ng.IPromise<PaymentMethodSearchViewModel> = this.searchGateway.loadPageInitializationData();
        loadPageInitializationDataPromise.then((viewModel: PaymentMethodSearchViewModel) => {
            this.logger.debug("loadPageInitializationDataPromise", viewModel);
            this.searchViewModel = viewModel;
            this.searchCriteriaModel.submissionStatusTypeCodeName = "Bound";
        });
    }


    public submit(): void {

        this.searchViewModel.isDataGridLoading = true;

        this.searchGateway.loadSearchResults(this.searchCriteriaModel, this.searchViewModel)
            .then((viewModel: PaymentMethodSearchViewModel) => {
                this.logger.debug("loadSearchResultsPromise", viewModel);
                this.searchViewModel = viewModel;
                this.searchViewModel.isDataGridLoading = false;
            });
    }

    

}


